<template>
  <div
    :class="[$style.buttons, $style[alignment]]"
    data-qa="buttons"
  >
    <slot
      name="default"
      :push="$style.push"
    />
  </div>
</template>

<script setup lang="ts">
/**
 * @deprecated Используйте `import { UiStack } from '@huntflow/ui';` вместо этого компонента.
 * Причина: Этот компонент не поддерживается, будет удалён после полного перехода на ui-kit
 */
const { alignment = 'start' } = defineProps<{
  alignment?: 'start' | 'center' | 'between' | 'end';
}>();
</script>

<style lang="less" module>
.buttons {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  width: 100%;
  align-items: center;
  & > * {
    flex: none;
  }
}
.start {
  justify-content: flex-start;
}
.center {
  justify-content: center;
}
.between {
  justify-content: space-between;
}
.end {
  justify-content: flex-end;
}
.push {
  margin-inline-start: auto;
}
</style>

<i18n lang="json">{}</i18n>
